// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_ol-0";
export var buttonContainer = "_ol-3";
export var cancelButton = "_ol-4";
export var headerSection = "_ol-6";
export var headerTitle = "_ol-9";
export var messageSideLeft = "_ol-1";
export var messageSideRight = "_ol-2";
export var orderNumberContainer = "_ol-7";
export var orderNumberLabel = "_ol-8";
export var submitButton = "_ol-5";